import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import OrganizationsApp from './OrganizationsApp';

const Organizations = props => (
  <Router basename={`/${props.basename}`}>
    <Route path="/:stage?" render={matchProps => <OrganizationsApp {...props} {...matchProps} />} />
  </Router>
);

Organizations.propTypes = {
  basename: PropTypes.string.isRequired,
};

export default Organizations;